import isNil from 'lodash/isNil'
import OLSourceXYZ from 'ol/source/XYZ'
import TileState from 'ol/TileState'

import { getObjectURLImage } from 'aws/storage'

export default function (loaderType, config) {
  if (loaderType === 'awss3') {
    const configLoader = { ...config, tileLoadFunction }
    return new OLSourceXYZ(configLoader)
  } else {
    console.log('XYZ loader type not supported!')
    return null
  }
}

async function tileLoadFunction (tile, filename) {
  const objectURL = await getObjectURLImage('public', filename)
  if (!isNil(objectURL)) {
    tile.getImage().src = objectURL
  } else {
    tile.setState(TileState.ERROR)
  }
}
